interface RedirectIfNotRegisteredProps {
  navigate: (path: string, action?: 'push' | 'replace', ...args: any[]) => void
  pathname: string
  isRegistered: boolean
  loadingCustomer: boolean
}

export const redirectIfNotRegistered = ({
  navigate,
  pathname,
  isRegistered,
  loadingCustomer,
}: RedirectIfNotRegisteredProps) => {
  if (!loadingCustomer && !isRegistered) {
    navigate('/login', 'push', {directedFrom: pathname})
    return true
  }
  return false
}
